<template>
  <el-dialog class="el-dialogs" :append-to-body="true" :title="title" width="500px" :close-on-click-modal="false"
             :visible.sync="visible">
    <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
             @keyup.enter.native="doSubmit()" @submit.native.prevent style="height: 300px"
             label-width="110px">
      <el-form-item label="节点名称：" prop="nodeName">
        <el-select
            v-model="searchForm.nodeName"
            style="width: 100%"
            filterable
            allow-create
            default-first-option
            placeholder="请选择节点名称">
          <el-option
              v-for="item in nodeNameList"
              :key="item.id"
              :label="item.semanticName"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="父节点：" prop="parentId">
        <treeSelect ref="menuParentTree"
                    class="inputWidth"
                    :props="{
                                           children: 'children',
                                           label: 'nodeName',
                                           value:'id'
                                          }"
                    :data="fatherNodeList"
                    :value="searchForm.parentId"
                    :clearable="true"
                    :accordion="true"
                    @getValue="selectCascader"
        ></treeSelect>
      </el-form-item>
      <el-form-item label="状态：" prop="nodeState">
        <el-switch
            v-model="searchForm.nodeState"
            active-value="1"
            inactive-value="0">
        </el-switch>
      </el-form-item>
      <el-form-item label="备注：" prop="nodeRemark">
        <el-input
            type="textarea"
            :rows="5" maxlength="500" resize="none"
            placeholder="请输入备注(限500字)"
            v-model.trim="searchForm.nodeRemark">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
      <el-button size="small" @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import treeSelect from "@/components/treeSelect/treeSelect.vue";

export default {
  name: "nodeAdd",
  components: {treeSelect},
  data() {
    return {
      title: '新增节点',
      visible: false,
      searchForm: {
        id: '',
        modelId: '',
        nodeName: '',
        parentId: '',
        nodeState: '0',
        nodeRemark: '',
        semanticCorpusId: '',
      },
      rules: {
        nodeName: [
          {required: true, message: '请选择节点名称', trigger: 'blur'}
        ],
      },
      fatherNodeList: [],
      nodeNameList: [],

      selectData: {},
      setlectListData: {},
      levelData:'',
    }
  },

  methods: {
    init(type, row, setlectListData, parentId) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.searchForm.resetFields();
      })
      this.searchForm.id = ''
      this.searchForm.modelId = setlectListData.id
      if (type == 'add') {
        this.title = '新增'
        this.getOthers(parentId)
      } else {
        this.title = '编辑'
        this.selectData = row
        this.setlectListData = setlectListData
        this.searchForm.id = row.id
        this.getDetail()
      }
    },

    getOthers(parentId) {
      this.$axios(this.api.academic.semanticcorpusQueryList, {}).then(data => {
        if (data && data.status) {
          this.nodeNameList = data.data
        }
      })
      this.$axios(this.api.user.configKey + 'knowledge_model').then(data => {
        if (data && data.status) {
          this.levelData = data.data
          this.getParint(parentId)
        }
      })
    },

    getParint(parentId) {
      this.$axios(this.api.academic.knowledgemodelnodeGetByKnowledgeModelId + this.searchForm.modelId, {}).then(data => {
        if (data && data.status) {
          this.fatherNodeList = data.data
          this.setNodeDisabled(this.fatherNodeList)
          this.$nextTick(() => {
            this.searchForm.parentId = parentId
          })
        } else {
          this.$message.error(data.msg)
        }
      })
    },

    setNodeDisabled(data){
      if(!data.length)return
      data.forEach(item=>{
        if (item.level >= this.levelData){
          this.$set(item,'disabled',true)
        }
        this.setNodeDisabled(item.children)
      })
    },

    getDetail() {
      this.$axios(this.api.academic.knowledgemodelnodeGetById + this.searchForm.id, {}).then(data => {
        if (data && data.status) {
          Object.keys(this.searchForm).forEach(key => {
            this.searchForm[key] = data.data[key]
          })
          this.getOthers(data.data.parentId)
        } else {
          this.$message.error(data.msg)
        }
      })
    },

    selectCascader(val, label, node) {
      this.searchForm.parentId = val
    },

    //提交
    doSubmit() {
      let reapt = this.nodeNameList.filter(item => this.searchForm.nodeName == item.id)
      if (reapt.length) {
        this.searchForm.semanticCorpusId = reapt[0].id
        this.searchForm.nodeName = reapt[0].semanticName
      }
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          if (this.searchForm.id) {
            this.$axios(this.api.academic.knowledgemodelnodeUpdateById, this.searchForm, 'put').then(data => {
              if (data && data.status) {
                this.$message.success('修改成功')
                this.visible = false
                this.$emit('refresh')
              } else {
                this.$message.error(data.msg)
              }
            })
          } else {
            this.$axios(this.api.academic.knowledgemodelnodeSave, this.searchForm, 'post').then(data => {
              if (data && data.status) {
                this.$message.success(data.data)
                this.visible = false
                this.$emit('refresh')
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        }
      });
    },
  },
}
</script>

<style scoped>

</style>